/* Angular */
import { createReducer, on } from '@ngrx/store';

/* Functions */
import { updateEntityInArray } from 'src/app/features/shared/functions';

/* actions */
import * as ProviderDoctorDataStoreActions from './provider-doctor-data-store.actions';

import { ProviderDoctor } from 'src/app/features/shared/models';

/* State key */
export const featureKey = 'ProviderDoctorDataStore';

/* State interface */
export interface ProviderDoctorState {
  isLoading?: boolean;
  providerDoctors?: ProviderDoctor[];
  activeProviderDoctor?: ProviderDoctor;
}

/* Initial values */
export const initialState: ProviderDoctorState = {
  isLoading: null,
  providerDoctors: null,
  activeProviderDoctor: null,
};

export const reducer = createReducer(
  initialState,
  on(ProviderDoctorDataStoreActions.GetProviderDoctors, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    ProviderDoctorDataStoreActions.GetProviderDoctorsSuccessful,
    (state, action) => ({
      ...state,
      providerDoctors: action.payload.providerDoctors,
      isLoading: false,
    }),
  ),

  on(
    ProviderDoctorDataStoreActions.GetProviderDoctorsFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(ProviderDoctorDataStoreActions.GetProviderDoctorById, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    ProviderDoctorDataStoreActions.GetProviderDoctorByIdSuccessful,
    (state, action) => ({
      ...state,
      /* TODO: replace item by id from data array */
      isLoading: false,
    }),
  ),

  on(
    ProviderDoctorDataStoreActions.GetProviderDoctorByIdFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(ProviderDoctorDataStoreActions.CreateProviderDoctor, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    ProviderDoctorDataStoreActions.CreateProviderDoctorSuccessful,
    (state, action) => ({
      ...state,
      providerDoctors: [
        ...(state.providerDoctors ?? []),
        action.payload.providerDoctor,
      ],
      isLoading: false,
    }),
  ),

  on(
    ProviderDoctorDataStoreActions.CreateProviderDoctorFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(ProviderDoctorDataStoreActions.UpdateProviderDoctor, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    ProviderDoctorDataStoreActions.UpdateProviderDoctorSuccessful,
    (state, action) => ({
      ...state,
      providerDoctors: updateEntityInArray<ProviderDoctor>(
        action.payload.id,
        action.payload.data,
        state.providerDoctors ?? [],
      ),
      isLoading: false,
    }),
  ),

  on(
    ProviderDoctorDataStoreActions.UpdateProviderDoctorFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(ProviderDoctorDataStoreActions.DeleteProviderDoctor, (state, action) => ({
    ...state,
    isLoading: true,
  })),

  on(
    ProviderDoctorDataStoreActions.DeleteProviderDoctorSuccessful,
    (state, action) => ({
      ...state,
      providerDoctors:
        state.providerDoctors?.filter(
          (item) => action.payload.id !== item.id,
        ) ?? [],
      isLoading: false,
    }),
  ),

  on(
    ProviderDoctorDataStoreActions.DeleteProviderDoctorFailure,
    (state, action) => ({
      ...state,
      isLoading: false,
    }),
  ),

  on(ProviderDoctorDataStoreActions.ResetState, () => initialState),
);
